<template>
  <div>
    <el-dialog
      :visible.sync="showModal"
      width="900px"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
    >
      <span slot="title" class="modal-title">{{ titulo }}</span>

      <div v-loading="loading">
        <el-alert
          v-if="!loading && historico.length === 0"
          title="Nenhuma notificação de WhatsApp foi enviada."
          type="info"
          show-icon
          :closable="false"
        />

        <el-table v-else :data="historico" size="small" style="width: 100%">
          <el-table-column label="Tipo" width="170">
            <template slot-scope="scope">{{ descricaoTemplate(scope.row.template) }}</template>
          </el-table-column>
          <el-table-column label="Telefone" width="130">
            <template slot-scope="scope">{{ scope.row.telefone }}</template>
          </el-table-column>
          <el-table-column label="Status" width="110">
            <template slot-scope="scope">
              <el-tag :type="corStatus(scope.row.status)" size="mini">{{ scope.row.status.toUpperCase() }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="Agendado para">
            <template slot-scope="scope">{{ scope.row.agendado_para ? toDate(scope.row.agendado_para) : "---" }}</template>
          </el-table-column>
          <el-table-column label="Enviado em">
            <template slot-scope="scope">{{ scope.row.enviado_em ? toDate(scope.row.enviado_em) : "---" }}</template>
          </el-table-column>
        </el-table>
      </div>

      <span slot="footer">
        <el-button type="danger" @click="showModal = false">Fechar</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Rest from "common/rest";
import Fct from "common/fct";

export default {
  name: "historico-whatsapp",
  mixins: [Rest, Fct],
  props: {
    parent: {
      type: Object,
      default: null,
    },
    endpoint: {
      type: String,
      default: "empresa/consulta/liberacao",
    },
    idAntesDoSufixo: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      loading: false,
      showModal: false,
      historico: [],
      idRecurso: null,
    };
  },
  computed: {
    titulo() {
      return "HISTÓRICO DE NOTIFICAÇÕES WHATSAPP" + (this.idRecurso ? " - " + this.idRecurso : "");
    },
  },
  watch: {
    "parent.showHistoricoWhatsapp"(val) {
      this.showModal = val;
      if (val) {
        this.buscar();
      }
    },
    showModal(val) {
      if (!val) {
        this.parent.showHistoricoWhatsapp = false;
      }
    },
  },
  methods: {
    descricaoTemplate(template) {
      var mapa = {
        assinar_aso: "Assinatura de ASO",
        lembrete_assinar_aso: "Lembrete de assinatura",
        atualizar_matricula_contador: "Atualizar matrícula (contador)",
      };
      return mapa[template] || template;
    },
    corStatus(status) {
      var mapa = {
        agendado: "warning",
        enviado: "success",
        cancelado: "info",
        falhou: "danger",
      };
      return mapa[status] || "info";
    },
    buscar() {
      this.idRecurso = this.parent.historicoWhatsappId;

      if (!this.idRecurso) return;

      this.loading = true;

      var url = this.idAntesDoSufixo
        ? `${this.endpoint}/${this.idRecurso}/historico-whatsapp`
        : `${this.endpoint}/${this.idRecurso}`;

      this.get(url)
        .then((result) => {
          result = result[0];
          this.loading = false;

          if (result.status == 200 && result.data) {
            this.historico = result.data;
          } else {
            this.historico = [];
          }
        })
        .catch((e) => {
          console.log(e);
          this.loading = false;
          this.historico = [];
        });
    },
  },
};
</script>



// WEBPACK FOOTER //
// historico-whatsapp.vue?85f33632